/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPAddress } from './IPAddress';
import {
    IPAddressFromJSON,
    IPAddressFromJSONTyped,
    IPAddressToJSON,
    IPAddressToJSONTyped,
} from './IPAddress';

/**
 * 
 * @export
 * @interface PaginatedIPAddressList
 */
export interface PaginatedIPAddressList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedIPAddressList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedIPAddressList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedIPAddressList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<IPAddress>}
     * @memberof PaginatedIPAddressList
     */
    results: Array<IPAddress>;
}

/**
 * Check if a given object implements the PaginatedIPAddressList interface.
 */
export function instanceOfPaginatedIPAddressList(value: object): value is PaginatedIPAddressList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedIPAddressListFromJSON(json: any): PaginatedIPAddressList {
    return PaginatedIPAddressListFromJSONTyped(json, false);
}

export function PaginatedIPAddressListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedIPAddressList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(IPAddressFromJSON)),
    };
}

  export function PaginatedIPAddressListToJSON(json: any): PaginatedIPAddressList {
      return PaginatedIPAddressListToJSONTyped(json, false);
  }

  export function PaginatedIPAddressListToJSONTyped(value?: PaginatedIPAddressList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(IPAddressToJSON)),
    };
}

